/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type Tutor_tutor = {|
  +id: string;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Tutor_tutor",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "id",
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TutorJobs_tutor",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TutorHeader_tutor",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "TutorToolbar_tutor",
      "args": null
    }
  ],
  "type": "Tutor"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/modules/admin/tutor/__generated__/Tutor_tutor.graphql.js